import { faAlarmClock, faClock } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactElement } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Project } from "./Project";

interface IProps {
	project: Project;
}

export const ProjectBlock = (props: IProps): ReactElement => {
	const history = useHistory();
	const project = props.project;
	const stats = project.userStats;
	return (
		<Col sm={2}>
			<div
				className="card-wrapper text-center"
				onClick={() => history.push(project.dashboardLink)}
			>
				<Card className={`project-background-${project.color}`}>
					<Card.Body>
						<Row>
							<Col>
								<span
									className={`stat-block ${
										!stats || stats.totalTasksDueToday > 0
											? "due-today"
											: ""
									} `}
									data-tip="Tasks due today"
								>
									<FontAwesomeIcon
										icon={faClock}
										fixedWidth
									/>
									{stats ? stats.totalTasksDueToday : 0}
								</span>
							</Col>
							<Col>
								<span
									className={`stat-block ${
										!stats || stats.totalTasksOverdue > 0
											? "overdue"
											: ""
									} `}
									data-tip="Tasks overdue"
								>
									<FontAwesomeIcon
										icon={faAlarmClock}
										fixedWidth
									/>
									{stats ? stats.totalTasksOverdue : 0}
								</span>
							</Col>
						</Row>
					</Card.Body>
				</Card>
				<strong className="project-title mt-3 mb-3">
					{project.name}
				</strong>
			</div>
		</Col>
	);
};
